import { getAuth, signOut } from 'firebase/auth';

const logout = async () => {
  const auth = getAuth();

  await signOut(auth);
};

export default logout;
